import {Component, ChangeDetectionStrategy, Input, OnInit} from '@angular/core';
import { DropDownAnimation } from '../../../../assets/animations/dropdown';
import {CommonModule} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {SafeHtmlPipe} from "../../../pipes/safe-html.pipe";

@Component({
  selector: 'app-culture-item',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    SafeHtmlPipe,
    TranslateModule
  ],
  templateUrl: './culture-item.component.html',
  styleUrls: ['./culture-item.component.scss'],
  animations: [DropDownAnimation]
})
export class CultureItemComponent implements OnInit {

  @Input() culture: any;
  isOpen: boolean;

  constructor() {
    this.isOpen = false;
  }

  ngOnInit(): void {
  }

  toggleDropdown() {
    if (!this.culture.content) {
      return;
    }
    this.isOpen = !this.isOpen;
  }
}
